import { ThumbDownOutlined as ThumbDownOutlineIcon } from '@mui/icons-material';

const ThumbDownOutline = (): JSX.Element => <ThumbDownOutlineIcon fontSize="inherit" />;

export default ThumbDownOutline;
